export default [
  {
    path: '/support/notice',
    name: 'notice',
    component: () => import('@/views/support/support-app.vue'),
    children: [
      {
        path: 'list',
        name: 'noticeList',
        component: () => import('@/views/support/comp/notice-list.vue'),
      },
    ]
  },
  {
    path: '/support/faq',
    name: 'faq',
    component: () => import('@/views/support/support-app.vue'),
    children: [
      {
        path: 'list',
        name: 'faqList',
        component: () => import('@/views/support/comp/faq-list.vue'),
      },
    ]
  },
  {
    path: '/support/inquiry',
    name: 'inquiry',
    component: () => import('@/views/support/support-app.vue'),
    children: [
      {
        path: 'list',
        name: 'inquiryList',
        component: () => import('@/views/support/comp/inquiry-list.vue'),
      },
    ]
  },
    //1:1문의하기 작성
  {
    path: '/support/inquiry/write',
    name: 'inquiryWrite',
    component: () => import('@/views/support/comp/inquiry-write.vue'),
  },
]